function getApiToken() {
  var authinfo = loadApiToken();
  var ck =
    authinfo.apiauthinfo.cid +
    authinfo.apiauthinfo.cs +
    "__" +
    authinfo.apiauthinfo.uid;
  var r = {
    Accept: "application/json",
    Authorization: authinfo.apitoken.tk,
    contact_key: ck,
  };
  return r;
}

function loadApiToken() {
  var apiToken = sessionStorage.getItem("apiToken");
  apiToken = decryptObj(apiToken);
  var dt = new Date();
  if (
    !apiToken ||
    !apiToken.expire_dt ||
    (apiToken && dt.getTime() > new Date(apiToken.expire_dt).getTime())
  ) {
    var apiAuthInfo = sessionStorage.getItem("apiAuthInfo");
    apiAuthInfo = decryptObj(apiAuthInfo);
    var xurl = "https://auth." + apiAuthInfo.d + "/oauth2/token";
    var xdata = {
      grant_type: "client_credentials",
      client_id: apiAuthInfo.cid,
      client_secret: apiAuthInfo.cs,
    };
    am.$.ajax({
      type: "POST",
      url: xurl,
      data: xdata,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      success: function (response) {
        sessionStorage.removeItem("apiToken");
        var dt = new Date();
        var currentTime = dt.getTime();
        var updatedTIme = new Date(currentTime + response.expires_in);
        var newApiToken = {
          tk: response.access_token,
          expires_in: response.expires_in,
          token_type: response.token_type,
          expire_dt: updatedTIme,
          update_dt: dt,
        };
        sessionStorage.setItem(
          "apiToken",
          encryptString(JSON.stringify(newApiToken))
        );
        apiToken = newApiToken;
      },
    });
  }
  var r = { apitoken: apiToken, apiauthinfo: apiAuthInfo };
  return r;
}

function loadApiAuthInfo(client_id, client_secret, user_id, domain) {
  var apiAuthInfo = sessionStorage.getItem("apiAuthInfo");
  var rebuildAuthInfo = true;
  apiAuthInfo = decryptObj(apiAuthInfo);
  if (
    apiAuthInfo &&
    apiAuthInfo.cid === client_id &&
    apiAuthInfo.cs === client_secret &&
    apiAuthInfo.uid === user_id &&
    apiAuthInfo.d === domain
  ) {
    rebuildAuthInfo = false;
  }
  if (rebuildAuthInfo == true) {
    sessionStorage.removeItem("apiAuthInfo");
    var newapiAuthInfo = {
      cid: client_id,
      cs: client_secret,
      uid: user_id,
      d: domain,
    };
    sessionStorage.setItem(
      "apiAuthInfo",
      encryptString(JSON.stringify(newapiAuthInfo))
    );
    apiAuthInfo = newapiAuthInfo;
  }
  return apiAuthInfo;
}

function encryptString(string) {
  var passphrase = sessionStorage.getItem("sagebrush");
  if (!passphrase) {
    sessionStorage.removeItem("sagebrush");
    sessionStorage.setItem("sagebrush", generateUUIDString());
    passphrase = sessionStorage.getItem("sagebrush");
  }
  var cipher = CryptoJS.AES.encrypt(string, passphrase);
  cipher = cipher.toString();
  return cipher;
}

function decryptString(string) {
  var passphrase = sessionStorage.getItem("sagebrush");
  if (passphrase) {
    var decipher = CryptoJS.AES.decrypt(string, passphrase);
    decipher = decipher.toString(CryptoJS.enc.Utf8);
    return decipher;
  } else {
    return string;
  }
}

function decryptObj(obj) {
  if (obj) {
    obj = decryptString(obj);
    if (IsJson(obj)) {
      obj = JSON.parse(obj);
    }
    return obj;
  }
  return null;
}

function generateUUIDString() {
  return "xxxxxxxxxxxxxxxxxx".replace(/[x]/g, (c) => {
    const r = Math.floor(Math.random() * 16);
    return r.toString(16);
  });
}

function IsJson(str) {
  if (str == null) {
    return false;
  } else {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }
}

function findURLParam(param) {
  var url = window.location.toString();
  var check = "" + param;
  if (url.search(check) >= 0) {
    return url.substring(url.search(check)).split("&")[0].split("=")[1];
  }
}

function get_currency_symbol() {
  var r = document
    .getElementsByTagName("body")[0]
    .getAttribute("data-currency_symbol");
  return r;
}

function get_currency_abbr(type = "user") {
  // defaulted to user currency abbv(USD,EUR,ETC) but has freedom to use io currency symbol if desired
  const $symbol = am.$("#" + type + "-currency-abbr"); // user-currency-symbol || io-currency-symbol
  return $symbol.val();
}

function set_client_ip_address() {
  return new Promise((resolve, reject) => {
    try {
      // Check if we have cached location data
      const loctrack = localStorage.getItem("loctrack");
      if (loctrack) {
        resolve(JSON.parse(loctrack));
        return;
      }

      // Try to fetch geolocation data from external API (client-side)
      am.$.ajax({
        url: "https://ipv4.seeip.org/jsonip",
        dataType: "json",
        timeout: 5000, // 5 second timeout
        success: function (json) {
          try {
            // Cache the geolocation data
            localStorage.setItem("loctrack", JSON.stringify(json));

            // Send IP to server to store in session
            am.$.get("/ajax/settings/set_client_ip?cip=" + json.ip)
              .done(function (result) {
                resolve(json); // Resolve with the full geo data
              })
              .fail(function (jqXHR, textStatus) {
                // Server call failed, but we have the location data
                console.warn("Failed to set client IP on server:", textStatus);
                resolve(json); // Still resolve with geo data
              });
          } catch (err) {
            reject(err);
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.warn("External API failed, trying server-side fallback...");
          
          // Fallback: External API failed from client, try server-side
          am.$.ajax({
            url: "/ajax/settings/get_client_ip",
            dataType: "json",
            timeout: 6000, // 6 second timeout (server tries external API with 5s timeout)
            success: function (geoData) {
              try {
                // Cache the geolocation data from server
                localStorage.setItem("loctrack", JSON.stringify(geoData));
                console.log('Geolocation data from server fallback:', geoData);
                resolve(geoData);
              } catch (err) {
                console.warn("Unable to cache location data:", err);
                resolve(geoData);
              }
            },
            error: function () {
              reject(new Error("Failed to get location data: " + textStatus));
            }
          });
        }
      });
    } catch (err) {
      console.log('err catch set_client_ip_address: ' + err);
      reject(err);
    }
  });
}

function build_translation_storage(lang) {
  // We use localStorage instead of sessionStorage because the first is persisted across tabs
  try {
    if (
      localStorage.lang !== lang ||
      (findURLParam("rebuildtranslations") &&
        findURLParam("rebuildtranslations") * 1 === 1)
    ) {
      localStorage.removeItem("translations");
    }
    savedTranslationDOY = localStorage.getItem("translationsdoy");
    if (
      !savedTranslationDOY ||
      savedTranslationDOY.length === 0 ||
      getDOY() * 1 != savedTranslationDOY * 1
    ) {
      localStorage.removeItem("translations");
    }
    //if it is not json rebult
    let savedTranslations = null;
    try {
      savedTranslations = localStorage.getItem("translations");
      JSON.parse(savedTranslations);
    } catch (err) {
      savedTranslations = "";
      localStorage.removeItem("translations");
    }

    if (!savedTranslations || savedTranslations.length === 0) {
      localStorage.setItem("lang", lang);
      am.$.get(
        "/ajax/language/get_language_object/?lang=" + lang,
        function (data, status) {
          localStorage.setItem("translations", JSON.stringify(data));
          localStorage.setItem("translationsdoy", getDOY());
        }
      );
    }
  } catch (err) {
    console.error(err);
  }
}

/**
 * @param {string} key
 * @param {Object|null} variables
 *
 * @example
 * get_language_translation("LANG_RENAME");
 * get_language_translation("LANG_MESSAGE_WITH_VARIABLES", {"count": 3});
 */
function get_language_translation(key, variables = {}) {
  try {
    const $translations = JSON.parse(localStorage.getItem("translations"));
    /**@var {string} translation*/
    let translation = $translations[key];
    if(!translation || translation === undefined) {
      console.log("translation not found for key: ", key);
      return key;
    }
    if (
      null !== variables &&
      typeof variables === "object" &&
      !Array.isArray(variables)
    ) {
      Object.entries(variables).forEach(([k, val]) => {
        translation = translation.replaceAll(`%${k}%`, val);
      });
    }

    return translation;
  } catch (err) {
    // DEV-12790: before the async translation fetch lands (first page load of the
    // day — the store is cleared daily), localStorage 'translations' is null,
    // JSON.parse(null)[key] throws, and returning undefined here made callers like
    // formatDate() crash on .toLowerCase() — killing the rest of the page's inline
    // init. The documented miss behavior is "return the key"; hold it on ANY failure.
    return key;
  }
}

function build_user_permission_storage(cid, rebuild) {
  try {
    var sscid = sessionStorage.getItem("cid") * 1;
    var ucid = cid * 1;
    var sscperm = sessionStorage.getItem("cperm");
    sscperm = decryptObj(sscperm);
    var forcerebuild = false;
    if (sscid !== ucid || rebuild == true || isNaN(ucid) || ucid == 0) {
      sessionStorage.removeItem("cperm");
      sessionStorage.removeItem("cid");
      forcerebuild = true;
    }
    // DEV-13127: no contact (anonymous visitor, cid=0) means nothing to fetch - the
    // storage was just cleared above; asking the server for contact 0 was a wasted
    // request on every public page load (and a 500 until the handler learned to say {}).
    if (isNaN(ucid) || ucid <= 0) {
      return;
    }
    if (((!sscperm || sscperm.length === 0) && ucid > 0) || forcerebuild) {
      sessionStorage.setItem("cid", ucid);
      am.$.get(
        "/ajax/contacts/user_permissions/?cid=" + ucid,
        function (data, status) {
          sessionStorage.setItem("cperm", encryptString(JSON.stringify(data)));
        }
      );
    }
  } catch (err) {}
}

function get_user_permission_storage(key) {
  try {
    var $cperm = sessionStorage.getItem("cperm");
    var $r = false;
    $cperm = decryptObj($cperm);
    if ($cperm[key]) {
      $r = true;
    }
    return $r;
  } catch (err) {}
}

function build_company_roles(cid) {
  try {
    if (cid > 0) {
      if (!sessionStorage.role || sessionStorage.role.length === 0) {
        am.$.get(
          "/ajax/companies/get_all_roles/?cid=" + cid,
          function (data, status) {
            sessionStorage.setItem("role", encryptString(JSON.stringify(data)));
          }
        );
      }
    }
  } catch (err) {}
}

function get_company_role(key) {
  try {
    var $crole = sessionStorage.getItem("role");
    var $r = false;
    $crole = decryptObj($crole);
    if ($crole[key]) {
      $r = true;
    }
    return $r;
  } catch (err) {
    console.log(err, "err");
  }
}

function appcuesCheck() {
  try {
    var flowid = findURLParam("flowid");
    if (flowid && flowid.length > 0) {
      try {
        Appcues.show(flowid);
      } catch (err) {}
    }
  } catch (err) {
    console.log(err, "err");
  }
}

function build_browser_device_info() {
  var $body = am.$("body");
  if (is_touch_enabled()) {
    $body.addClass("touch_supported");
  } else {
    $body.addClass("touch_notsupported");
  }
  if (!am.$.fn.deviceDetector) return;
  var d = am.$.fn.deviceDetector.getInfo();
  $body.addClass("browser_id_" + d.browserId);
  $body.addClass(
    "browser_name_" + d.browserName.replace(/ /g, "_").toLowerCase()
  );
  $body.addClass("os_name_" + d.osName.replace(/ /g, "_").toLowerCase());
  $body.addClass("os_id_" + d.osId);
  $body.addClass("device_ismobile_" + d.mobile);

  try {
    if (d.mobile == true) {
      var toggler = $("content_wrapper");
      toggler.addClassName("shutside");
    }
  } catch (err) {}
}

function getDOY() {
  const today = new Date();
  const dayOfYear = Math.floor(
    (today - new Date(today.getFullYear(), 0, 0)) / 1000 / 60 / 60 / 24
  );
  return dayOfYear;
}

function check_all_option() {
  var $allck = am.$(".js-filter_all_checkbox");

  am.$.each($allck, function (k, v) {
    var $v = am.$(v);
    var $allId = $v.data("checkboxes");
    var $cks = am.$("#" + $allId + " .js-filter_checkbox");
    var $checkedCks = 0;
    var $totalCks = $cks.length;

    am.$.each($cks, function (key, value) {
      if (am.$(value).is(":checked")) {
        $checkedCks++;
      }
    });
    if ($checkedCks == $totalCks) {
      $v.prop("checked", true);
    } else {
      $v.prop("checked", false);
    }
  });
}

function watch_check_all_option() {
  am.$(".js-filter_checkbox").on("change", function () {
    check_all_option();
  });
}

function save_tags_api(tagEvent) {
  // Don't save tags if they're in a filter form (used for filtering, not editing)
  const tagElement = document.getElementById(tagEvent.detail.current_element.id);
  if (tagElement && (tagElement.closest('.filter') || tagElement.closest('form.filter'))) {
    return;
  }

  const pathSegments = window.location.pathname.split("/").filter(Boolean);

  const pathConfigs = {
    "home/time_card": { table: "save_tags_for_contact" },
    "accounts/companies/edit": {
      table: "save_tags_for_company",
      idKey: "company_id",
      idIndex: 3,
    },
    "orders/quote": {
      table: "save_tags_for_order_quote",
      idKey: "order_id",
      idIndex: 2,
    },
    "orders/allocation": {
      table: "save_tags_for_order_allocation",
      idKey: "order_id",
      idIndex: 2,
    },
    "orders/output": {
      table: "save_tags_for_order_output",
      idKey: "order_id",
      idIndex: 2,
    },
    "accounts/individual/edit": {
      table: "save_tags_for_individual",
      idKey: "individual_id",
      idIndex: 3,
    },
    "accounts/individual": {
      table: "save_tags_for_individual",
      idKey: "individual_id",
      idIndex: 2,
    },
    "accounts/companies": {
      table: "save_tags_for_company",
      idKey: "company_id",
      idIndex: 2,
    },
    "catalog/products/edit": {
      table: "save_tags_for_product",
      idKey: "product_id",
      idIndex: 3,
    },
    "components/edit": {
      table: "save_tags_for_component",
      idKey: "component_id",
      idIndex: 3,
    },
    "inventory/edit": {
      table: "save_tags_for_inventory",
      idKey: "inventory_id",
      idIndex: 2,
    },
    "inventory/view": {
      table: "save_tags_for_inventory",
      idKey: "inventory_id",
      idIndex: 2,
    },
    "accounts/contacts/time_card/": {
      table: "save_tags_for_other_contact",
      idKey: "other_contact_id",
      idIndex: 3,
    },
    "catalog/resell/local_catalog/product/edit/": {
      table: "save_tags_for_local_catalog_products",
      idKey: "dynamic_entity_id",
      idIndex: 5,
    },
  };
  const form_payload = {
    tags: document.getElementById(tagEvent.detail.current_element.id).value,
  };
  const pathKey = Object.keys(pathConfigs).find((key) =>
    pathSegments.join("/").includes(key)
  );

  if (pathKey) {
    const config = pathConfigs[pathKey];
    form_payload.table = config.table;
    if (config.idKey) {
      const entityId = pathSegments[config.idIndex];
      // Don't save if entity ID is missing or invalid (e.g., on list pages)
      if (!entityId || entityId === '' || isNaN(parseInt(entityId))) {
        return;
      }
      form_payload[config.idKey] = entityId;
    }
  } else {
    console.warn("No matching path found.");
    return;
  }

  am.$.post("/ajax/", form_payload)
    .done(() => {
      const action_text =
        tagEvent.type === "tag_added"
          ? get_language_translation("LANG_ADDED")
          : get_language_translation("LANG_LABEL_REMOVED");
      const message =
        get_language_translation("LANG_TAG") +
        ' "' +
        tagEvent.detail.current_tag_name +
        '" ' +
        get_language_translation("LANG_LABEL_HAS_BEEN") +
        " " +
        action_text +
        ".";

      show_snackbar({
        message,
        type: "success",
        timer: 4000,
        showClose: false,
        fromUndo: true,
      });
    })
    .fail((jqXHR, textStatus, errorThrown) => {
      console.error("Error saving tags:", textStatus, errorThrown);
    });
}
function select_children_tree() {
  const checkboxes = document.querySelectorAll(".js-checkbox-item");

  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", function () {
      const parentId = this.getAttribute("value");
      const isChecked = this.checked;

      // Handle children when parent is clicked
      const childCheckboxes = document.querySelectorAll(
        `[data-parentid="${parentId}"]`
      );
      childCheckboxes.forEach((childBox) => {
        childBox.checked = isChecked;
      });

      // Handle parent when child is clicked
      const thisParentId = this.getAttribute("data-parentid");
      if (thisParentId) {
        const parentCheckbox = document.querySelector(
          `.js-checkbox-item[value="${thisParentId}"]`
        );
        if (parentCheckbox) {
          // Parent is only checked if ALL children are checked
          const siblings = document.querySelectorAll(
            `[data-parentid="${thisParentId}"]`
          );
          const allChecked = Array.from(siblings).every(
            (sibling) => sibling.checked
          );
          parentCheckbox.checked = allChecked;
        }
      }
    });
  });
}

function init_category_trees() {
  document.querySelectorAll(".am-tree").forEach(function (tree) {
    if (tree.querySelector(".am-skeleton")) return;
    if (tree.getAttribute("data-tree-init")) return;
    var rows = Array.prototype.slice.call(
      tree.querySelectorAll(".am-tree__row")
    );
    if (!rows.length) return;
    tree.setAttribute("data-tree-init", "1");

    function depthOf(r) {
      return parseInt(r.style.getPropertyValue("--tree-depth"), 10) || 0;
    }
    function isLastChild(i) {
      var d = depthOf(rows[i]);
      for (var j = i + 1; j < rows.length; j++) {
        var dj = depthOf(rows[j]);
        if (dj < d) return true;
        if (dj === d) return false;
      }
      return true;
    }

    var lastAt = [];
    rows.forEach(function (row, i) {
      var d = depthOf(row);
      var last = isLastChild(i);
      lastAt[d] = last;
      var frag = "";
      for (var k = 0; k < d; k++) {
        if (k < d - 1) {
          frag +=
            '<span class="am-tree__guide' +
            (lastAt[k + 1] ? "" : " am-tree__guide--trunk") +
            '"></span>';
        } else {
          frag +=
            '<span class="am-tree__guide am-tree__guide--conn ' +
            (last ? "am-tree__guide--last" : "am-tree__guide--mid") +
            '"></span>';
        }
      }
      if (frag) row.insertAdjacentHTML("afterbegin", frag);
    });

    var collapsed = {};
    function recompute() {
      rows.forEach(function (r, idx) {
        var d = depthOf(r),
          hidden = false,
          need = d;
        for (var j = idx - 1; j >= 0 && need > 0; j--) {
          var pj = depthOf(rows[j]);
          if (pj < need) {
            if (collapsed[j]) {
              hidden = true;
              break;
            }
            need = pj;
          }
        }
        r.style.display = hidden ? "none" : "";
      });
    }
    // A toggle rendered with aria-label="Expand" starts its subtree collapsed
    // (server-chosen initial state — e.g. the announcements contact chooser opens
    // closed like its legacy widget did). Existing trees render "Collapse" and are
    // unaffected.
    var seeded = false;
    rows.forEach(function (row, idx) {
      var btn = row.querySelector(".am-tree__toggle");
      if (btn && btn.getAttribute("aria-label") === "Expand") {
        collapsed[idx] = true;
        seeded = true;
      }
    });
    if (seeded) recompute();
    rows.forEach(function (row, idx) {
      var btn = row.querySelector(".am-tree__toggle");
      if (!btn) return;
      btn.addEventListener("mousedown", function (e) {
        e.stopPropagation();
      });
      btn.addEventListener("click", function (e) {
        e.stopPropagation();
        e.preventDefault();
        var isCollapse = btn.getAttribute("aria-label") === "Collapse";
        btn.setAttribute("aria-label", isCollapse ? "Expand" : "Collapse");
        collapsed[idx] = isCollapse;
        recompute();
      });
    });

    function clearLit() {
      tree.querySelectorAll(".am-tree__guide--lit").forEach(function (g) {
        g.classList.remove("am-tree__guide--lit");
      });
      tree.querySelectorAll(".am-tree__row.is-lit").forEach(function (r) {
        r.classList.remove("is-lit");
      });
    }
    tree.addEventListener("mouseover", function (e) {
      var row = e.target.closest(".am-tree__row");
      if (!row || !tree.contains(row)) return;
      clearLit();
      var idx = rows.indexOf(row),
        d = depthOf(row),
        anc = [],
        cur = d;
      anc[cur] = idx;
      for (var j = idx - 1; j >= 0 && cur > 0; j--) {
        var pj = depthOf(rows[j]);
        if (pj < cur) {
          anc[pj] = j;
          cur = pj;
        }
      }
      for (var k = 0; k < d; k++) {
        for (var m = anc[k]; m <= idx; m++) {
          var g = rows[m].querySelectorAll(".am-tree__guide")[k];
          if (g) g.classList.add("am-tree__guide--lit");
        }
      }
      row.classList.add("is-lit");
    });
    tree.addEventListener("mouseleave", clearLit);
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const treeContainer = document.querySelector(".js-disable-tree");
  if (!treeContainer) return;

  // Add enable button
  const enableButton = document.createElement("button");
  enableButton.textContent = "Edit Categories";
  enableButton.className =
    "am-btn am-btn--filled am-btn--fullwidth";
  treeContainer.parentNode.insertBefore(enableButton, treeContainer);

  function showSelectedItemsWithParents() {
    // Get all checkboxes within the tree container
    const checkboxes = treeContainer.querySelectorAll(".js-checkbox-item");

    // First hide all items and make checkboxes readonly
    checkboxes.forEach((checkbox) => {
      const listItem = checkbox.closest("li");
      listItem.style.display = "none";
      checkbox.onclick = () => false;
      checkbox.onkeydown = () => false;
      checkbox.classList.add("readonly-checkbox");

      //checkbox.disabled = true;  // Make checkbox readonly
    });

    // Show checked items and their parents
    checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        // Show the checked item
        const listItem = checkbox.closest("li");
        listItem.style.display = "";

        // Show all parent items
        let parentId = checkbox.getAttribute("data-parentid");
        while (parentId) {
          const parentCheckbox = treeContainer.querySelector(
            `.js-checkbox-item[value="${parentId}"]`
          );
          if (parentCheckbox) {
            const parentListItem = parentCheckbox.closest("li");
            parentListItem.style.display = "";
            // Get next parent ID
            parentId = parentCheckbox.getAttribute("data-parentid");
          } else {
            break;
          }
        }
      }
    });

    // Show parent UL elements
    treeContainer.querySelectorAll("li").forEach((li) => {
      if (li.style.display !== "none") {
        const parentUl = li.closest("ul");
        if (parentUl) {
          parentUl.style.display = "";
        }
      }
    });
  }

  function enableTree() {
    // Show all items
    treeContainer.querySelectorAll("li").forEach((li) => {
      li.style.display = "";
    });

    // Enable all checkboxes
    treeContainer.querySelectorAll(".js-checkbox-item").forEach((checkbox) => {
      checkbox.onclick = () => true;
      checkbox.onkeydown = () => true;
      checkbox.classList.remove("readonly-checkbox");

      // checkbox.disabled = false;
    });

    // Show all ULs
    treeContainer.querySelectorAll("ul").forEach((ul) => {
      ul.style.display = "";
    });

    // Hide enable button
    enableButton.style.display = "none";
  }

  // Initial state: show only selected
  showSelectedItemsWithParents();

  // Add click handler to enable button
  enableButton.addEventListener("click", enableTree);
});

// Debug helper function
function isDebugMode() {
  return window.location.search.includes("showmetheerror=1");
}
function debugLog(message) {
  if (isDebugMode()) {
    console.log(message);
  }
}

function save_tags(this_instance) {
  MoxForm.Go(this_instance, null, false, '', save_tags_api);
}

["tag_added", "tag_removed"].forEach(eventType => {
  document.addEventListener(eventType, (userEvent) => {
    const isTagSomethingDialog = userEvent.detail.isTagSomethingDialog;
    if (!is_entity_creation_page() && !isTagSomethingDialog) {
      setTimeout(() => save_tags_api(userEvent));
    }
  });
});

is_entity_creation_page = () => window.location.href.includes("/new/");

let last_activity_time = Date.now();

const update_activity = () => (last_activity_time = Date.now());
function was_active_with_in(interval_in_minutes = 10) {
  const intervalMs = interval_in_minutes * 60 * 1000;
  return Date.now() - last_activity_time <= intervalMs;
}

function invoke_last_active_on_various_events() {
  [
    "mousemove",
    "mousedown",
    "mouseup",
    "click",
    "wheel",
    "contextmenu",
    "keydown",
    "keyup",
    "pointerdown",
    "pointermove",
    "pointerup",
  ].forEach((event) =>
    document.addEventListener(event, update_activity, { passive: true })
  );
}

invoke_last_active_on_various_events();

// Debug helper function
function isDebugMode() {
  return window.location.search.includes("showmetheerror=1");
}

function debugLog(message, from=false) {
  if (isDebugMode()) {
    if(from) {
      console.log({dataFrom: from, debugData: message});
    } else {
      console.log(message);
    }
  }
}

// Global lock to prevent duplicate announcement saves
let globalAnnouncementSaveInProgress = false;

function handle_modal_open(is_from_modal = true, announcement_callback) {
  document
    .querySelectorAll(".am-btn.am-btn--filled")
    .forEach(function (link) {
      link.removeAttribute("onclick");
    });
  const dynamicFormId = is_from_modal
    ? "new_announcement_form"
    : "full_announcement_form";
  const announcementInputId = is_from_modal
    ? "announcement"
    : "full_page_announcement_input";
  const dynamicAnnouncementForm = is_from_modal
    ? "new_announcement_form"
    : "full_announcement_form";
  document
    .querySelectorAll(
      "#" +
        dynamicAnnouncementForm +
        " .am-btn.am-btn--filled"
    )
    .forEach(function (link) {
      // Check if handler already attached using data attribute to prevent duplicates
      if (link.dataset.saveHandlerAttached === 'true') {
        return; // Already has handler, skip
      }
      link.dataset.saveHandlerAttached = 'true';
      
      // Store handler reference for potential cleanup
      let isProcessing = false;
      const clickHandler = function (e) {
        // Global lock check - prevent any duplicate saves across all instances
        if (globalAnnouncementSaveInProgress) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }
        
        // Prevent duplicate submissions - check if already processing
        if (isProcessing) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }
        
        // Prevent default form submission and event bubbling
        e.preventDefault();
        e.stopImmediatePropagation();
        
        if (
          !simpleValidateHtmlStr(
            CKEDITOR.instances[announcementInputId].getData()
          ) ||
          !CKEDITOR.instances[announcementInputId].getData()
        ) {
          am.$("#cke_" + announcementInputId).addClass("validation-failed");
          GUI.error_message(
            am.$("#cke_" + announcementInputId)[0],
            "_cke_" + announcementInputId,
            get_language_translation("LANG_LABEL_INVALID_VALUE")
          );
          // Validation failed - allow retry, so don't set isProcessing
          return;
        }
        
        // Mark as processing and disable button immediately
        // Set global lock FIRST to prevent race conditions
        globalAnnouncementSaveInProgress = true;
        isProcessing = true;
        link.classList.add("pointer-events-none");
        link.style.opacity = "0.6";
        link.style.cursor = "not-allowed";
        show_loading_svg();

        const form = am.$("#" + dynamicFormId)[0];
        const formData = new FormData(form);
        const announcement_payload = {
          announcement: CKEDITOR.instances[announcementInputId].getData(),
          unformatted_expiration_date: formData.get(
            "unformatted_expiration_date"
          ),
          announcement_location_and_type: formData.get(
            "announcement_location_and_type"
          ),
          hide_when_expired: formData.get("hide_when_expired"),
          show_as_banner: formData.get("show_as_banner"),
          expiration_date: formData.get("expiration_date"),
          contacts: formData.getAll("contacts[]"),
          n_contacts: formData.getAll("n_contacts[]"),
        };

        // Store the AJAX request to prevent duplicate submissions
        if (link.dataset.ajaxRequestInProgress === 'true') {
          // Request already in progress, don't submit again
          // Reset the global lock since we're not actually submitting
          globalAnnouncementSaveInProgress = false;
          isProcessing = false;
          link.classList.remove("pointer-events-none");
          link.style.opacity = "1";
          link.style.cursor = "pointer";
          hide_loading_svg();
          return;
        }
        link.dataset.ajaxRequestInProgress = 'true';

        am.$.ajax({
          url: "/ajax/save_announcements/",
          type: "POST",
          data: announcement_payload,
          success: (data) => {
            try {
              // Handle case where response might have multiple JSON objects concatenated
              // Extract the first valid JSON object
              let jsonStr = data;
              if (typeof data === 'string') {
                // Find the first complete JSON object
                let firstBrace = jsonStr.indexOf('{');
                if (firstBrace !== -1) {
                  let braceCount = 0;
                  let endIndex = firstBrace;
                  for (let i = firstBrace; i < jsonStr.length; i++) {
                    if (jsonStr[i] === '{') braceCount++;
                    if (jsonStr[i] === '}') braceCount--;
                    if (braceCount === 0) {
                      endIndex = i + 1;
                      break;
                    }
                  }
                  jsonStr = jsonStr.substring(firstBrace, endIndex);
                }
                data = JSON.parse(jsonStr);
              } else {
                data = data; // Already parsed by jQuery
              }
            } catch (e) {
              console.error('Error parsing response:', e, data);
              globalAnnouncementSaveInProgress = false;
              isProcessing = false;
              link.classList.remove("pointer-events-none");
              link.style.opacity = "1";
              link.style.cursor = "pointer";
              link.dataset.ajaxRequestInProgress = 'false';
              hide_loading_svg();
              show_snackbar({
                message: 'Error processing response',
                type: 'danger',
              });
              return;
            }
            if (data && data.status === 200) {
              // Add a small delay to ensure server has processed any dismissals before refreshing
              setTimeout(() => {
                populate_page_announcements(true);
              }, 100);
              link.classList.remove("pointer-events-none");
              link.style.opacity = "1";
              link.style.cursor = "pointer";
              isProcessing = false;
              globalAnnouncementSaveInProgress = false;
              link.dataset.ajaxRequestInProgress = 'false';
              document.querySelector(".fal.fa-times").click();
              $page_dismiss_all_button.fadeIn();
              show_snackbar({
                message: data.message,
                type: "success",
              });
              am.$("#_cke_" + announcementInputId).remove();
              am.$("#cke_" + announcementInputId).removeClass(
                "validation-failed"
              );
            } else if (data && data.status == 400) {
              link.classList.remove("pointer-events-none");
              link.style.opacity = "1";
              link.style.cursor = "pointer";
              isProcessing = false;
              globalAnnouncementSaveInProgress = false;
              link.dataset.ajaxRequestInProgress = 'false';
              show_snackbar({
                message: data.message,
                type: "danger",
              });
            }
          },
          error: (e) => {
            console.log(e, "e");
            link.classList.remove("pointer-events-none");
            link.style.opacity = "1";
            link.style.cursor = "pointer";
            isProcessing = false;
            globalAnnouncementSaveInProgress = false;
            link.dataset.ajaxRequestInProgress = 'false';
            show_snackbar({
              message: e.message,
              type: "danger",
            });
          },
          complete: () => {
            hide_loading_svg();
            // Ensure processing flag is reset
            globalAnnouncementSaveInProgress = false;
            link.dataset.ajaxRequestInProgress = 'false';
            document.dispatchEvent(new Event("announcement_added"));
            if (!is_from_modal) {
              announcement_callback();
            }
          },
        });
      };
      
      link.addEventListener("click", clickHandler);
    });
  document.removeEventListener("modal:open", handle_modal_open);
}
